import { InternalMessageBusChannels } from "sb-resp-lib";
import { ModelItem, filterItemType, filterItemTypeMap } from "../itemTypes";
import { DatesModel } from "../../modes";
import { IMessageBus } from "..";

export interface IMessageSender {
    SendMessage(item: ModelItem): void;
}

export class MessageSender implements IMessageSender {

    private readonly messageBus: IMessageBus;
    private readonly channelPrefix: string;

    constructor(messageBus: IMessageBus, channelPrefix: string){
        this.messageBus = messageBus;
        this.channelPrefix = channelPrefix;
    }

    SendMessage(item: ModelItem) {
        const message = messageGenerator[item.type](item);
        const channel = `${this.channelPrefix}.${InternalMessageBusChannels.eventsFilter[item.type]}`;
        this.messageBus.emit(channel, message);
    }
}

const messageGenerator: filterItemTypeMap<(item: any) => object, filterItemType> = {
    sports: (item: ModelItem) => ({ sportIds: [item.id] }),
    allSports:(_) => ({ sportIds: [] }),
    favorites: (_) => ({}),
    liveStream: (_) => ({}),
    dates: (item: DatesModel) => ({
        dateRange: {
            from: item.from,
            timeRange: item.timeRange
        }
    })
}